import $ from 'jquery';

const init = () => {
    $('.text table').wrap('<div class="table_wrap-ckeditor">');
};

export default init();
